import { Serializer } from "../resource/serializer.interface";
import { ContactDetailsHistory } from "./contact-details-history.model";

export class ContactDetailsHistorySerializer implements Serializer {
    fromJson(json: any): ContactDetailsHistory {
        const contactDetailsHistory = new ContactDetailsHistory();
        contactDetailsHistory.id = json.id;
        contactDetailsHistory.emailAddress = json.email_address;
        contactDetailsHistory.coreContactFieldId = json.coreContactField_Id;
        contactDetailsHistory.value = json.value;
        contactDetailsHistory.formId = json.form_Id;
        contactDetailsHistory.pageId = json.page_Id;
        contactDetailsHistory.tenantId = json.tenant_id;
        contactDetailsHistory.dateCreated = json.created_at;
        return contactDetailsHistory;
    }

    toJson(contactDetailsHistory: ContactDetailsHistory): any {
        return {
            id: contactDetailsHistory.id,
            email_address: contactDetailsHistory.emailAddress,
            coreContactField_Id: contactDetailsHistory.coreContactFieldId,
            value: contactDetailsHistory.value,
            form_Id: contactDetailsHistory.formId,
            page_Id: contactDetailsHistory.pageId,
            tenant_id: contactDetailsHistory.tenantId,
            created_at	: contactDetailsHistory.dateCreated
        };
    }
}
